export default "__VITE_ASSET__6c8a716e__"